import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BellOff, Settings } from "lucide-react";
import { registerNativePush, nativePushPermission, openNotificationSettings } from "@/utils/nativePush";

/* Active les push natifs au moment opportun (première arrivée sur le tableau
   de bord restaurant/livreur, PAS au premier lancement de l'app) et affiche un
   rappel si la permission a été refusée — réactivable dans les réglages du
   téléphone. Ne rend rien hors app native ou si tout est déjà autorisé. */
export default function PushPermissionBanner() {
  const { t } = useTranslation();
  const [state, setState] = useState("unsupported");

  useEffect(() => {
    let alive = true;
    (async () => {
      const perm = await nativePushPermission();
      if (!alive || perm === "unsupported") return;
      if (perm === "granted" || perm === "prompt" || perm === "prompt-with-rationale") {
        const res = await registerNativePush();
        if (alive) setState(res);
      } else {
        setState("denied");
      }
    })();
    return () => { alive = false; };
  }, []);

  if (state !== "denied") return null;
  return (
    <div className="mb-4 rounded-2xl border border-brand-red/30 bg-[#FFF5F6] p-4 flex items-start gap-3" data-testid="push-permission-banner">
      <BellOff className="w-5 h-5 text-brand-red shrink-0 mt-0.5" />
      <div className="text-sm flex-1 min-w-0">
        <div className="font-semibold">{t("push.disabledTitle")}</div>
        <p className="text-mute mt-0.5">{t("push.disabledText")}</p>
        <button onClick={() => openNotificationSettings()} data-testid="push-banner-open-settings-btn"
          className="mt-3 rounded-full bg-brand-red text-white px-4 py-2 text-sm font-semibold inline-flex items-center gap-2 hover:bg-ink transition-colors">
          <Settings className="w-4 h-4" /> {t("push.openSettings")}
        </button>
      </div>
    </div>
  );
}
